var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-list clearfix"},_vm._l((_vm.tags),function(item){return _c('div',{key:item.id,staticClass:"item-box"},[_c('div',{class:!!item.special && item.special == '1' ? 'tag-item special' : 'tag-item'},[_vm._v("\n      # "+_vm._s(item)+"\n    ")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0867e6f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/TagsList.vue
// module id = null
// module chunks = 